import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'cpExists'
})
export class ExistsPipe implements PipeTransform {
	transform(arr: string[]|any[], q: string,propertyName?:string,propertyFunc?:Function): boolean {
		if (!q || !arr) {
			return true;
		}
		return arr.some(v =>((
			(propertyName?
				(propertyFunc?propertyFunc(v[propertyName]):v[propertyName])
				:v)+'').toLowerCase()).includes(q.toLowerCase()));
	}
}
